import Request            from '../core/jsonRequest';
import $matchAllFilter    from './../core/filter/matchAll';
import $defaultPlantsSort from './../core/filter/defaultPlantsSort';
import appState           from './../state/app';
import Dexie              from 'dexie';
import infoDb             from './infoDb';
import AppSettings        from 'ro-webapp-backend/lib/models/app/settingsNames';
import fecha              from 'fecha';

const log = require('debug')('ro:markers-db');

const DB_NAME = 'ro_webapp_new_markers';

const TABLES = {
    MARKERS:      {
        name:    'markers',
        syncUrl: '/v1.0/db/markers/updated',
        indexes: 'id, plant_id, article_id'
    },
    PLANTS:       {
        name:    'plants',
        syncUrl: '/v1.0/db/plants/updated',
        indexes: 'id, name, name_en, name_lat, name_sk'
    },
    ARTICLES:     {
        name:    'articles',
        syncUrl: '/v1.0/db/articles/updated',
        indexes: 'id'
    },
    SEARCH_INDEX: {
        name:    'search_index',
        syncUrl: '/v1.0/db/search-index/updated',
        indexes: 'id, name, name_en, name_lat, name_sk, name_de, family_name, family_name_en'
    }
}

const VERSION = 1;

//extends Database
class Database {

    static get name() {
        return DB_NAME;
    }

    static get tables() {
        return TABLES
    }

    findOneById(tableName, id) {
        return this.db[tableName].get({id: id});
    }

    filterTable(tableName, filter, sort) {
        return this.db[tableName].filter(filter).toArray();
    }

    constructor(options) {
        this.name   = DB_NAME;
        this.exists = false;
        this.db     = new Dexie(this.name);
        //scheme+indexes
        let stores  = {};
        Object.keys(TABLES).map((tableKey) => {
            stores[TABLES[tableKey].name] = TABLES[tableKey].indexes;
        });
        this.db.version(VERSION).stores(stores);
    }

    async $schemaOutdated() {
        log(`Current db version is ${this.db.verno}, schema version is ${VERSION}`);
        let outdated = false;
        if (this.db.verno < VERSION) {
            outdated = true;
        }
        return outdated;
    }

    /**
     *
     * @param {Object} table
     * @return {Promise<void>}
     */
    async $syncWithRemote(table) {
        log(`Syncing table ${table.name}, sync url: ${table.syncUrl}`);
        let latestUpdatedDate = await infoDb.getLatestUpdateDate(table.name);
        if (!latestUpdatedDate) {
            log(`Table ${table.name} never updated before`);
            latestUpdatedDate = '1970-01-01 00:00:00';
        } else {
            log(`Table ${table.name} lastly updated at ${latestUpdatedDate}`)
        }
        let next        = true;
        let page        = 1;
        let progress    = Infinity;
        let totalCount  = Infinity;
        let rowsPerPage = 50;
        let updated     = 0;
        let inserted    = 0;
        let deleted     = 0;
        let lastItemUpdateDate;
        while (next) {
            let data   = await new Request(`api${table.syncUrl}?from=${encodeURIComponent(latestUpdatedDate)}&rowsPerPage=${rowsPerPage}&page=${page}`, {method: 'get'}).fetch();
            totalCount = data.count;
            if (!data.rows || !data.rows.length) {
                next               = false;
                progress           = 0;
                lastItemUpdateDate = latestUpdatedDate;
                continue;
            }
            if (data.rows && data.rows.length < rowsPerPage) {
                next     = false;
                progress = data.count;
            } else {
                progress = page * rowsPerPage;
            }
            log(`Table ${table.name} processing ${data.rows.length}`);
            for (let i = 0; i < data.rows.length; i++) {
                if (!data.rows[i].active) {
                    await this.db[table.name].delete(data.rows[i].id);
                    deleted++;
                    continue;
                }
                let item = await this.db[table.name].get({id: data.rows[i].id});
                if (item) {
                    await this.db[table.name].put(data.rows[i]);
                    updated++
                } else {
                    await this.db[table.name].add(data.rows[i]);
                    inserted++
                }
                lastItemUpdateDate = data.rows[i].updated_at;
            }
            page++;
        }
        log(`All items in ${table.name} synced (updated:${updated}, inserted:${inserted}, deleted: ${deleted}). Last updated date: ${lastItemUpdateDate}`);
        await infoDb.setLatestUpdateDate(table.name, lastItemUpdateDate);
        //next
    }



    async sync() {
        log(`Syncing DB ${this.name} ...`);
        await this.db.open();
        let schemaOutdated = await this.$schemaOutdated();
        let tableKeys      = Object.keys(TABLES);
        for (let i = 0; i < tableKeys.length; i++) {
            let tableName = TABLES[tableKeys[i]].name;
            let count     = await await this.db[tableName].count();
            log(`Table ${tableName} got ${count} items`);
            if ((!count && schemaOutdated) || !this.db[tableName]) {
                throw new Error('Unable to continue. App needs to be updated!');
            }
            if (!count) {
                await infoDb.setLatestUpdateDate(tableName, new Date(0).getTime());
            }
            await this.$syncWithRemote(TABLES[tableKeys[i]]);
        }

        // if (!count && !schemaOutdated) {
        // return
        // }


        // let localDbMeta = {};
        // let remoteDbLatestUpdate = new Date();
        // if (localDbMeta.latestUpdate === remoteDbLatestUpdate) {
        //     //up to date
        //     return;
        // }
        // //update needed
        // let updatedFromDate = localDbMeta.latestUpdate;
        // let updatedItems = remoteDb.getUpdated(updatedFromDate, 10);
        // while (updatedFromDate < localDbMeta.latestUpdate) {
        //     updatedItems.map((item) => {
        //         if (item.deleted_at) {
        //             localDb.deleteById(item.id);
        //         } else {
        //             localDb.updateById(item.id, item);
        //         }
        //         updatedFromDate = item.updated_at;
        //     })
        // }
    }

    // async $fetchLocalRowsIndex() {
    //     let allDocs = await this.$fetchAllLocalRows();
    //     let index = {};
    //     if (allDocs.length === 0) {
    //         return {};
    //     }
    //
    //     allDocs.map((item) => {
    //         index[item.type + '_' + item.id] = item.updated_at;
    //     });
    //     return index;
    // }

    // async $fetchRemoteRowsIndex() {
    //     return new Request('/api/v1.0/markers', {method: 'get'}).fetch()
    //     .then((rows) => {
    //         this.remoteMarkersTemp = rows;
    //         let index = {};
    //         rows.map((row) => {
    //             index[row.type + '_' + row.id] = row.updated_at;
    //         });
    //         console.log('remote idx', index);
    //         return index;
    //     })
    // }
    //
    // async sync() {
    //     log('Syncing ', this.name);
    //     let updateInfo = await this.getUpdateInfo();
    //     log('Update nfo ', this.name, updateInfo);
    //     if (!updateInfo.needsUpdate) {
    //         let docCount = await this.$getDocCount();
    //         return {docCount: docCount};
    //     }
    //
    //     await this.clearAll();
    //     let count = await this.$getDocCount();
    //     for (let i = 0; i < this.remoteMarkersTemp.length; i++) {
    //         this.remoteMarkersTemp[i].id = this.remoteMarkersTemp[i].type + '_' + this.remoteMarkersTemp[i].id;
    //         await this.$addRow(this.remoteMarkersTemp[i]);
    //     }
    //     let docCount = await this.$getDocCount();
    //     return {docCount: docCount};
    // }
    //
    // //not needed!
    // async search(filter = $matchAllFilter, sort = $defaultPlantsSort) {
    //     return super.search(filter, sort);
    // }
}

export default Database;


// WEBPACK FOOTER //
// ./src/database/database.js